import React, {
    Fragment, useCallback, useState, useEffect, useRef,
} from 'react';
import { createPortal } from 'react-dom';
import { useDropzone } from 'react-dropzone';

import { getDocumentsUrl } from '../utilities/urlHelper';

import CategoryAndFolderSelect from '../components/move/CategoryAndFolderSelector';

const Dropzone = (props) => (
    <div {...props.getRootProps()} className={`grey dropzone px3 py4 btn block regular rounded bg-darken-1 center ${props.isDragActive ? 'active' : ''}`}>
        <span><span className="icon-file" /></span>
        <label htmlFor="file-upload" className="m0">Drop .pdf file here or click to select a file</label>
        <input {...props.getInputProps()} id="file-upload" type="file" accept="application/pdf" multiple={false} className="display-none" />
    </div>
);

const FileComponent = (props) => (
    <div className="mt2 mb2">
        <div className="rounded-2 p2 border flex flex-start shadow">
            <img className="mr1" src="/img/icons/file-icon-document.png" height="24px" alt="File Icon" />
            <span className="flex-auto md-text bold break-word">
                {props.originalPdfName}
.pdf
            </span>
            <button className="btn btn-small flex-none gray" style={{ lineHeight: '1' }} onClick={props.removeFile}>×</button>
        </div>
    </div>
);

const ImportDocumentModal = () => {

    const [file, setFile] = useState(null);
    const [showModal, setShowModal] = useState();
    const [fileName, setFileName] = useState('');
    const [errorText, setErrorText] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const hiddenInputRef = useRef();

    const onClick = useCallback((e) => {
        e.preventDefault();
        setShowModal(true);
    }, []);

    const onClickModal = useCallback(({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            setShowModal(false);
        }
    }, []);

    useEffect(() => {
        document.querySelectorAll('[data-trigger-add-document]').forEach((el) => el.addEventListener('click', onClick));
        return () => document.querySelectorAll('[data-trigger-add-document]').forEach((el) => el.removeEventListener('click', onClick));
    }, []);

    // clear the modal state when it closes
    useEffect(() => {
        if (!showModal) {
            setFile(null);
            setFileName('');
            setErrorText(null);
        }
    }, [showModal]);

    const onDrop = useCallback((acceptedFiles) => {
        if (!acceptedFiles || !acceptedFiles.length) return;
        const file = acceptedFiles[0];
        const fileName = file.name.split('.').slice(0, -1).join('.');
        setFileName(fileName);
        setFile(file);

        if (hiddenInputRef.current) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            hiddenInputRef.current.files = dataTransfer.files;
            setErrorText(null);
        }
    }, []);

    const onDropRejected = useCallback((files) => {
        if (files.length > 1) {
            return setErrorText('Error: Only one file can be uploaded at a time');
        }
        setErrorText('Error: File must be .pdf < 50mb');
    }, []);

    const onChangeTitle = (e) => {
        setFileName(e.target.value);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        e.target.submit();
    };

    const removeFile = useCallback(() => {
        setFile(null);
        setFileName('');
    }, []);

    const DROP_ZONE_CONFIG = {
        onDrop,
        onDropRejected,
        accept: { 'application/pdf': ['.pdf'] },
        maxFiles: 1,
        maxSize: 52428800, // 50mb
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone(DROP_ZONE_CONFIG);

    const isDisabled = !file || !fileName || isSubmitting;
    const submitButtonText = isSubmitting ? 'Adding file...' : 'Add file';
    const initialCategoryId = window?.categoryId;
    const folderId = window?.folderId;
    const originalPdfName = file?.name.split('.').slice(0, -1).join('.') || '';

    return showModal && createPortal(
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content">
                <h2>Add a document to Tettra</h2>
                <p className="gray">Documents show up in page lists and are searchable like pages.</p>
                { errorText && <div className="mb2 red">{errorText}</div> }
                {!file && <Dropzone getRootProps={getRootProps} getInputProps={getInputProps} isDragActive={isDragActive} />}
                <form
                    encType="multipart/form-data"
                    action={getDocumentsUrl()}
                    method="POST"
                    onSubmit={onSubmit}
                >
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <input type="file" name="input-file" style={{ display: 'none' }} ref={hiddenInputRef} />
                    {file && (
                        <Fragment>
                            <FileComponent originalPdfName={originalPdfName} removeFile={removeFile} />
                            <label htmlFor="file-title" className="bold block col-12 mb1 mt1">Document title</label>
                            <input name="file-title" type="text" className="block col-12 mb2 field" value={fileName} placeholder="Document title" onChange={onChangeTitle} />
                            <input name="file" type="hidden" value={file} />
                            <CategoryAndFolderSelect selectOnly initialCategoryId={initialCategoryId} initialFolderId={folderId} />
                            <div className="right-align mt2">
                                <span role="button" className="btn btn-secondary" onMouseDown={() => setShowModal(false)}>Cancel</span>
                                <input type="submit" className="btn btn-primary ml1 " disabled={isDisabled} value={submitButtonText} />
                            </div>
                        </Fragment>
                    )}

                </form>
            </div>
        </div>,
        document.body,
    );
};

export default ImportDocumentModal;
